import { Component, OnInit } from '@angular/core';
import {UrlBuilder} from "../url-builder/url.builder";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Information} from "../information/information";

export interface Connection {
  rest: string;
  handler: string;
  auth: string;
}

@Component({
  selector: 'app-connection',
  templateUrl: './connection.component.html',
  styleUrls: ['./connection.component.css']
})
export class ConnectionComponent implements OnInit {
  private uiUrl: string = "";
  private url: UrlBuilder;
  public base: Connection | undefined;
  public token: Connection | undefined;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  ngOnInit(): void {
    this.GetBase().subscribe({
      next: connection => {
        this.base = connection;
      }});
    this.GetToken().subscribe({
      next: connection => {
        this.token = connection;
      }});

  }

  GetToken(): Observable<Connection> {
    this.uiUrl = this.url.GetConnectionTokenUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<Connection>(this.uiUrl);
  }

  GetBase(): Observable<Connection> {
    this.uiUrl = this.url.GetConnectionBaseUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<Connection>(this.uiUrl);
  }



}
